import { APP_URL } from '../config';
import { HeroVisual } from '../components/Visuals';

export default function Hero(): JSX.Element {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* soft accent glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 -top-24 mx-auto h-72 max-w-3xl rounded-full bg-accent/15 blur-3xl"
      />
      <div className="container-page relative grid items-center gap-12 py-16 md:py-24 lg:grid-cols-2">
        <div>
          <p className="eyebrow">A private dashboard for your Tesla</p>
          <h1 className="mt-3 text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">
            Everything your Tesla is doing — live.
          </h1>
          <p className="mt-5 max-w-xl text-lg text-muted">
            Garage streams telemetry straight from your Tesla, maps every drive,
            tracks trips and charging, and goes deeper than the app does — pack
            balance, motor temperatures, high-voltage health. All behind your
            passkey.
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a className="btn btn-primary btn-lg" href={`${APP_URL}/?request=1`}>
              Request early access
            </a>
            <a className="btn btn-ghost btn-lg" href={APP_URL}>
              Log in
            </a>
          </div>
          <p className="mt-4 text-sm text-muted">
            Invite-only · Passkey + MFA · No data ever sold · Built in the USA
          </p>
        </div>
        <HeroVisual />
      </div>
    </section>
  );
}
